var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
        _vm.$store.state.modalsStates.paymentStatus.open &&
        _vm.$store.state.modalsStates.paymentStatus.data
      )?_c('ModalPaymentStatus',{attrs:{"dialog":_vm.$store.state.modalsStates.paymentStatus.open &&
        _vm.$store.state.modalsStates.paymentStatus.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }